import { setFiltersByBusiness } from '@/utils/transformers/filters'

import ozModal from '@/components/oz-modal'
import businessTypeMixin from '@/mixins/business-type'
import { BUSINESS_TYPES_MASP_COMPONENT } from '@/utils/constants/filters'
import ozModalBody from '../oz-modal-body'

export default {
  name: 'oz-filters-modal',

  mixins: [businessTypeMixin],

  props: {
    isShowModal: { type: Boolean, required: true },
    filters: { type: Object, required: true },
    glossary: { type: Object, required: true },
    isResultPage: { type: Boolean },
  },

  data () {
    return {
      currentBusiness: {},
      constructionStatus: '',
    }
  },

  created () {
    const { business } = this.filters

    this.setInitialBussinessValue(business)
  },

  computed: {
    currentFilters () {
      const { constructionStatus } = this
      return { ...this.filters, ...this.currentBusiness, constructionStatus }
    },
  },

  methods: {
    setInitialBussinessValue (business) {
      const bt = BUSINESS_TYPES_MASP_COMPONENT.find((e) => e.value === business)
      const newBusiness = this.$_update_business(business)
      this.currentBusiness = newBusiness
      this.constructionStatus = this.filters.constructionStatus || newBusiness.constructionStatus
      this.businessValue = bt.value
    },

    toggleModal () {
      this.$emit('updateShowModal')
    },

    onFiltersUpdate (filters) {
      this.$emit('updateFilters', setFiltersByBusiness({ ...this.currentBusiness, ...filters }))
    },

    onSelect (businessType) {
      const business = this.$_update_business(businessType)
      this.businessValue = businessType
      this.currentBusiness = business
      this.constructionStatus = ''
    },

    onRemoveFilters () {
      const business = this.$_update_business(this.filters.business)
      const addresses = this.filters.addresses || null

      const defaultFilters = {
        addresses,
        portal: 'ZAP',
        size: 24,
        from: 0,
        categoryPage: 'RESULT',
        ...business,
      }
      this.$emit('removeFilters', defaultFilters)
    },

  },

  components: {
    ozModal,
    ozModalBody,
  },
}
